<script lang="ts" setup>
const { tournament } = defineProps<{ tournament: Tournament }>()
</script>

<template>
  <NuxtPage :tournament="tournament" />
</template>
